import React, { lazy, Suspense } from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import EmpSignin from "../pages/empSignin/empSignin";
import SureRoute from "../pages/sureRoute/sureRoute";
import PaymentDropIn from "pages/paymentDropIn/paymentDropIn";
import { StartOrder } from "pages/start/OrderStart";
// import AllStores from "../pages/allStores/allStores";
// import Cart from "../pages/cart/cart";
// import Homepage from "../pages/homepage/homepage";
// import Landing from "../pages/landingPage/landing";
// import PaymentFailure from "../pages/paymentFailure/paymentFailure";
// import PaymentProcess from "../pages/paymentProcess/paymentProcess";
// import PaymentSuccess from "../pages/paymentSuccess/paymentSuccess";
// import Products from "../pages/products/products";
// import Signup from "../pages/signup/signup";

const lazyWithRetry = (importFunc) => {
  return lazy(() =>
    importFunc().catch((error) => {
      if (
        error.message &&
        (error.message.includes("Loading chunk") ||
          error.message.includes("Failed to fetch"))
      ) {
        console.warn("Chunk load failed — forcing hard navigation...");
        window.location.replace(
          window.location.origin + "/?_cb=" + Date.now()
        );
      }
      throw error;
    })
  );
};

const AllStores = lazyWithRetry(() => import("../pages/allStores/allStores"));
const Cart = lazyWithRetry(() => import("../pages/cart/cart"));
const Homepage = lazyWithRetry(() => import("../pages/homepage/homepage"));
const Landing = lazyWithRetry(() => import("../pages/landingPage/landing"));
const PaymentFailure = lazyWithRetry(() =>
  import("../pages/paymentFailure/paymentFailure")
);
const PaymentProcess = lazyWithRetry(() =>
  import("../pages/paymentProcess/paymentProcess")
);
const PaymentSuccess = lazyWithRetry(() =>
  import("../pages/paymentSuccess/paymentSuccess")
);
const Products = lazyWithRetry(() => import("../pages/products/products"));
const Signup = lazyWithRetry(() => import("../pages/signup/signup"));
const ScanScreen = lazyWithRetry(() => import("../pages/scan/scan"));

const RouteSwitch = () => {
  return (
    <Suspense fallback={<div>Loading..!! Please wait</div>}>
      <Switch>
        <Route exact path="/" render={(props) => <Landing {...props} />} />
        <Route
          exact
          path="/start"
          render={(props) => <StartOrder {...props} />}
        />
        <Route
          exact
          path="/homepage"
          render={(props) => <Homepage {...props} />}
        />
        <Route
          exact
          path="/products/:storeId"
          render={(props) => <Products {...props} />}
        />
        <Route exact path="/cart" render={(props) => <Cart {...props} />} />
        <Route exact path="/signup" render={(props) => <Signup {...props} />} />
        <Route
          exact
          path="/payment"
          render={(props) => <PaymentDropIn {...props} />}
        />
        <Route
          exact
          path="/paymentSuccess/:orderId"
          render={(props) => <PaymentSuccess {...props} />}
        />
        <Route
          exact
          path="/paymentFailure/:orderId"
          render={(props) => <PaymentFailure {...props} />}
        />
        <Route
          exact
          path="/paymentProcess/:orderId?"
          render={(props) => <PaymentProcess {...props} />}
        />
        <Route
          exact
          path="/allStores"
          render={(props) => <AllStores {...props} />}
        />
        <Route
          exact
          path="/scan"
          render={(props) => <ScanScreen {...props} />}
        />
        <Route
          exact
          path="/empSignIn"
          render={(props) => <EmpSignin {...props} />}
        />
        <Route
          exact
          path="/sureroute-test-object"
          render={(props) => <SureRoute {...props} />}
        />
        <Redirect from="/" to="/" />
      </Switch>
    </Suspense>
  );
};

export default RouteSwitch;
